module.exports = __webpack_public_path__ + "static/media/reddick_li_xing_yang.16b39169.jpg";